import { ShieldAlert } from 'lucide-react'
import type { NavEntry } from '@/app/nav-registry'

/** Nav entries only — imported by the eager shell bundle; keep free of pages/api (H-10). */

export const carsNav: NavEntry = {
  label: 'CARs',
  icon: ShieldAlert,
  path: '/cars',
  permission: 'cars:read',
  order: 15,
}
